/**
    * @description      : 
    * @author           : 
    * @group            : 
    * @created          : 28/05/2025 - 13:52:13
    * 
    * MODIFICATION LOG
    * - Version         : 1.0.0
    * - Date            : 28/05/2025
    * - Author          : 
    * - Modification    : 
**/
import React from "react";
import Container from "react-bootstrap/Container";
import { Image } from "react-bootstrap";
import images from "../../images/index";
import { Link } from "react-router-dom";
const RegistrationNavbar = () => (
  <React.Fragment>
    <Container
      fluid
      className="navbar d-flex justify-content-between py-1 px-3 align-items-center"
    >
      <Link to="https://pv-glarecheck.com/" className="text-decoration-none">
        <div className="d-flex align-items-center">
        <Image
          className="logo"
          src={images.Logo}
          alt="logoHere"
          width={194}
          height={36}
        />
          {/* <p className="solarCalc">Solar Calc</p> */}
        </div>
      </Link>
      <div className="align-items-center ">
        <span className="regEN">EN</span> / <span className="regDU">DE</span>
      </div>
    </Container>
  </React.Fragment>
);

export default RegistrationNavbar;
